import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { axiosInstance } from '../api/config/axiosConfig';
import { API_ENDPOINTS } from '../api/endpoints/endpoints';

function formatCount(n: number): string {
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k+`;
  return `${n}+`;
}

const TrustIndicators: React.FC = () => {
  const { t } = useTranslation();
  const [activeListings, setActiveListings] = useState<string>('15k+');

  useEffect(() => {
    axiosInstance
      .get(API_ENDPOINTS.LISTINGS.GET_ALL, { params: { limit: 1 } })
      .then((res) => {
        const total: number = res.data?.pagination?.total;
        if (total != null && total > 0) {
          setActiveListings(formatCount(total));
        }
      })
      .catch(() => {
        // keep default value on error
      });
  }, []);

  return (
    <section className="hp-trust-section">
      <div className="hp-container">
        <div className="row">
          <div className="col-md-4 mb-4 mb-md-0">
            <div className="hp-stat-item">
              <div className="hp-stat-number">{activeListings}</div>
              <div className="hp-stat-label">{t('home.trust_active_listings')}</div>
            </div>
          </div>
          <div className="col-md-4 mb-4 mb-md-0">
            <div className="hp-stat-item">
              <div className="hp-stat-number">2.5k+</div>
              <div className="hp-stat-label">{t('home.trust_verified_dealers')}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="hp-stat-item">
              <div className="hp-stat-number">98%</div>
              <div className="hp-stat-label">{t('home.trust_satisfaction')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;
